import CloseIcon from '@mui/icons-material/Close';
import { useSnackbar } from 'notistack';
import { User } from '@auth0/auth0-react';
import { QModal, QModalTitle, QModalContent, QModalActions, QButton, QTypography } from '@kw/quokka-ui';
import { sendHttpRequest } from '../../utils/network.service';

export const DeleteUserModal = ({ user, isOpen, onCancel, onDelete }: IProps) => {
  const { enqueueSnackbar } = useSnackbar();

  const DeleteUser = async () => {
    const successMessage = `Successfully deleted ${user.name}`;
    const errorMessage = `Error deleting ${user.name}`;

    // Delete user
    await sendHttpRequest({
      path: `${process.env.ORGANIZATION_SERVICE_URL}/organizations/users/delete/${user.user_id}`,
      method: 'DELETE',
      successMessage,
      errorMessage,
      enqueueSnackbar,
    });

    onDelete();
  };

  return (
    <QModal
      open={isOpen}
      aria-labelledby="issue-type-modal-title"
      aria-describedby="issue-types-modal"
      onClose={onCancel}
      onClick={e => e.stopPropagation()}
      title={
        <QModalTitle onClose={onCancel} closeIcon={<CloseIcon />}>
          <QTypography variant="h3Medium" id="issue-type-modal-title">
            Delete User
          </QTypography>
        </QModalTitle>
      }
      content={
        <QModalContent id="confirmation-modal-description">
          <QTypography variant="bodyRegular">Are you sure you want to delete {user.name} ?</QTypography>
        </QModalContent>
      }
      actions={
        <QModalActions>
          <QButton variant="outlined" onClick={onCancel}>
            Cancel
          </QButton>
          <QButton variant="filled" onClick={() => DeleteUser()}>
            Delete
          </QButton>
        </QModalActions>
      }
    />
  );
};

interface IProps {
  isOpen: boolean;
  onCancel: () => void;
  onDelete: () => void;
  user: User;
}
